<template>
  <div class="document_list">
    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="wrap-device-list_bg">
      <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
        <div class="filters">
          <div class="filter">
            <fg-input
                v-model="filter.q"
                type="text"
                class="search_user"
                :placeholder="translate('diadoc.documents.search')"
                :clearable="true"
                @input="change_input"
            />
          </div>

          <div class="filter">
            <tree-select
                :options="group_list"
                :multiple="false"
                v-model="filter.document_group_id"
                :placeholder="translate('diadoc.documents.document_group_name')"
                :clearable="true"
                @input="change_input"
            />
          </div>

          <div class="filter">
            <tree-select
                :options="status_list"
                :multiple="false"
                v-model="filter.status"
                :placeholder="translate('diadoc.documents.docflow_status_text')"
                :clearable="true"
                @input="change_input"
            />
          </div>

          <div class="filter">
            <tree-select
                :options="category_list"
                :multiple="false"
                v-model="filter.category"
                :placeholder="translate('diadoc.documents.document_category')"
                :clearable="true"
                @input="change_input"
            />
          </div>
          <div class="filter">
            <WrapDatePicker
                type="date"
                v-model="date"
                :placeholder="translate('diadoc.documents.upload_period')"
                :range="true"
                :confirm="true"
                :clearable="true"
                value_type="X"
                @input="change_input"
            />
          </div>
        </div>

        <div class="buttons">
          <span
            v-if="diadoc_status?.needs_login"
            class="mdi mdi-plus-circle-outline btn btn-success btn-fill"
            @click.prevent="diadoc_auth"
          >
            <b>{{ translate('diadoc.documents.auth') }}</b>
          </span>
          <span
              v-else
              class="mdi mdi-update btn btn-success btn-fill"
              @click.prevent="update_diadoc_documents"
          >
            <b>{{ translate('diadoc.documents.update') }}</b>
          </span>
        </div>
      </div>
    </div>

    <div class="response_table">
      <div v-if="loading">
        <div class="spinner">
          <scale-loader />
        </div>
      </div>

      <table v-else>
        <thead>
          <tr>
            <th
                class="pointer w50"
                scope="col"
                :class="{ selected: filter_type === 'id' }"
                @click="change_filter('id')"
            >
              {{ translate('diadoc.documents.id') }}
              <i v-if="filter_type === 'id'" class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
            </th>
            <th
                class="pointer w10per text-left"
                scope="col"
                :class="{ selected: filter_type === 'counteragent_name' }"
                @click="change_filter('counteragent_name')"
            >
              {{ translate('diadoc.documents.counteragent_name') }}
              <i v-if="filter_type === 'counteragent_name'" class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
            </th>
            <th
                class="pointer w10per"
                scope="col"
                :class="{ selected: filter_type === 'type_named_id' }"
                @click="change_filter('type_named_id')"
            >
              {{ translate('diadoc.documents.type_named_id') }}
              <i v-if="filter_type === 'type_named_id'" class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
            </th>
            <th
                class="pointer text-left"
                scope="col"
                :class="{ selected: filter_type === 'title' }"
                @click="change_filter('title')"
            >
              {{ translate('diadoc.documents.title') }} / {{ translate('diadoc.documents.file_name') }}
              <i v-if="filter_type === 'title'" class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
            </th>
            <th class="w50" scope="col"></th>
            <th
                class="pointer w10per"
                scope="col"
                :class="{ selected: filter_type === 'docflow_status_text' }"
                @click="change_filter('docflow_status_text')"
            >
              {{ translate('diadoc.documents.docflow_status_text') }}
              <i v-if="filter_type === 'docflow_status_text'" class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
            </th>
            <th
                class="pointer w10per"
                scope="col"
                :class="{ selected: filter_type === 'document_category' }"
                @click="change_filter('document_category')"
            >
              {{ translate('diadoc.documents.document_category') }}
              <i v-if="filter_type === 'document_category'" class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
            </th>
            <th
                class="pointer w10per"
                scope="col"
                :class="{ selected: filter_type === 'document_group_name' }"
                @click="change_filter('document_group_name')"
            >
              {{ translate('diadoc.documents.document_group_name') }}
              <i v-if="filter_type === 'document_group_name'" class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
            </th>
            <th
                class="pointer w10per"
                scope="col"
                :class="{ selected: filter_type === 'diadoc_document_timestamp' }"
                @click="change_filter('diadoc_document_timestamp')"
            >
              {{ translate('diadoc.documents.uploaded_at') }}
              <i v-if="filter_type === 'diadoc_document_timestamp'" class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
            </th>
            <th
                class="pointer w10per"
                scope="col"
                :class="{ selected: filter_type === 'updated_at' }"
                @click="change_filter('updated_at')"
            >
              {{ translate('diadoc.documents.updated_at') }}
              <i v-if="filter_type === 'updated_at'" class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
            </th>
          </tr>
        </thead>
        <tbody>
          <router-link
              v-for="(diadoc,key) in sorted_diadocs"
              :key="key"
              :to="'/diadoc_document/' + diadoc.id"
              class="link"
          >
            <tr class="diadoc_document__item pointer">
              <td class="w50" :data-label="translate('diadoc.documents.id')"> {{ diadoc.id }} </td>
              <td class="w10per text-left" :data-label="translate('diadoc.documents.counteragent_name')"> {{ diadoc.counteragent_name }} </td>
              <td class="w10per" :data-label="translate('diadoc.documents.type_named_id')"> {{ diadoc.type_named_id }} </td>
              <td :data-label="translate('diadoc.documents.title')" >
                <p class="text-left limit" :title="diadoc.title">{{ diadoc.title }}</p>
                <p class="text-left limit" :title="diadoc.file_name"> {{ diadoc.file_name }} </p>
              </td>
              <td class="w50 vertical-center">
                <span
                    v-if="diadoc.file_url"
                    class="mdi mdi-download-box"
                    @click.stop.prevent="download_file(diadoc.file_url, diadoc.file_name)"
                />
                <span
                    v-if="has_start_tariffication(diadoc)"
                    class="mdi mdi-plus-box"
                    title="Создать тарификацию"
                    @click.stop.prevent="new_device_tariff(diadoc)"
                />
              </td>
              <td class="w10per" :data-label="translate('diadoc.documents.docflow_status_text')"> {{ diadoc.docflow_status_text }} </td>
              <td class="w10per" :data-label="translate('diadoc.documents.document_category')"> {{ diadoc.document_category }} </td>
              <td class="w10per" :data-label="translate('diadoc.documents.document_group_name')"> {{ diadoc.document_group_name }} </td>
              <td class="w10per" :data-label="translate('diadoc.documents.uploaded_at')" v-html="get_date_any_lines(diadoc.diadoc_document_timestamp, null, 2)"></td>
              <td class="w10per" :data-label="translate('diadoc.documents.updated_at')" v-html="get_date_any_lines(diadoc.updated_at, null, 2)"></td>
            </tr>
          </router-link>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";
import AddDeviceTariff from "../../../Tariffication/Tabs/TariffedDevices/Modal/AddDeviceTariff.vue";

export default {
  name: 'DiadocDocuments',
  props: {
    group_list: Array,
  },
  components: {
    WrapDatePicker,
  },
  data () {
    return {
      diadocs: [],
      filter_type: "",
      filter_asc: "asc",
      diadoc_status: null,
      loading: false,
      date: [],
      filter:{
        q: "",
        status: 'Требуется подпись',
        document_group_id: null,
        category: null
      },
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
    }
  },

  created () {
    this.check_auth_code()
    this.check_query()
    this.get_diadoc_status_auth()
  },

  activated () {
    this.check_query()
  },

  watch:{
    filter: {
      deep: true,
      handler() {
        this.update_query()
      }
    },
    date() {
      this.update_query()
    }
  },

  computed:{
    sorted_diadocs(){
      return [...this.diadocs].sort(this.compareNumbers)
    },
    send_filter(){
      let filter = {}
      Object.keys(this.filter).forEach((item) => {
        this.filter[item] !== null && this.filter[item] !== "" && this.filter[item] !== undefined ? filter[item] = this.filter[item] : ""
      })
      if (this.date && this.date[0] && this.date[1]) {
        filter.date_start = this.date[0]
        filter.date_end = this.date[1]
      }
      return filter
    },
    status_list(){
      return this.$store.getters.getDiadocDocument.statuses.map((status) => {
        return { id: status.id, label: status.title }
      })
    },
    category_list(){
      return this.$store.getters.getDiadocDocument.categories.map((category) => {
        return { id: category.id, label: category.title }
      })
    },

  },

  methods: {
    check_query() {
      for (let key in this.$route.query) {
        switch (key) {
          case 'q':
          case 'status':
          case 'category':
            this.filter[key] = this.$route.query[key]
            break;
          case 'document_group_id':
            this.filter.document_group_id = Number(this.$route.query[key])
            break;
          case 'date':
            this.date = this.$route.query[key].split(',')
            break;
        }
      }
      this.update_query()
      this.get_diadoc_document_list()
    },
    update_query() {
      if (this.$route.name !== 'diadoc_section' || this.$route.params.diadoc_section !== 'documents') return
      const query = {}
      Object.keys(this.filter).forEach(key => {
        if (this.filter[key] !== null && this.filter[key] !== undefined && this.filter[key] !== '') {
          query[key] = this.filter[key]
        }
      })
      if (this.date?.[0] && this.date?.[1]) query.date = this.date.join(',')
      if (this.$route.query.code) query.code = this.$route.query.code
      const target = { path: this.$route.path, query }
      if (this.$route.fullPath !== this.$router.resolve(target).route.fullPath) this.$router.push(target)
    },
    has_start_tariffication(diadoc) {
      return (diadoc.parse_results || []).some(result => result.start_device_tariffication_done === 0)
    },
    new_device_tariff(diadoc) {
      if (!this.has_start_tariffication(diadoc)) return
      this.$http.v1.getDiadocDocument(diadoc.id, (response) => {
        const action = (response.data.pending_actions || []).find(item => item.type === 'start_device_tariffication')
        if (!action?.enabled) {
          const problems = (action?.problems || []).map(problem => problem.message).join('\n')
          this.global_notify('info', problems || 'Постановка на тарификацию недоступна')
          return
        }
        const params = action.params || {}
        const t = this.$createElement(AddDeviceTariff, {
          props: {
            prop_device_fid: params.device_fid || params.fid || '',
            params,
            parse_result_id: action.parse_result_id
          },
          on: {
            close: () => this.$modal.hide('add_device_tariff'),
            confirm: () => this.$modal.hide('add_device_tariff')
          }
        })
        this.$modal.show({ render() { return t } }, {}, {
          height: 'auto',
          width: 800,
          adaptive: true,
          clickToClose: true,
          scrollable: true,
          name: 'add_device_tariff'
        })
      })
    },
    download_file(file_url, file_name){
      const baseUrl = process.env.VUE_APP_BASE_URL || window.location.origin;
      const url = new URL(file_url, new URL(baseUrl, window.location.origin)).href;
      const link = document.createElement('a');

      link.href = url;
      link.download = file_name;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.get_diadoc_document_list, 500)
    },
    update_diadoc_documents(){
      this.$http.v1.updateDiadocDocumentList((response) => {
        if (response) this.get_diadoc_document_list()
      })
    },
    check_auth_code(){
      if (this.$route.query && Object.keys(this.$route.query).length > 0){
        if (this.$route.query.code){
          this.$http.v1.postAuthCode({code: this.$route.query.code}, (response) => {
            if (response.data){
              history.pushState(null, null, this.$route.path)
            }
          })
        }
      }
    },
    diadoc_auth(){
      this.$http.v1.getAuthStart((response) => {
        response.data.url ? window.open(response.data.url) : null
      })
    },
    get_diadoc_status_auth(){
      this.$http.v1.getAuthStatusDiadoc((response) => {
        this.diadoc_status = response.data
      })
    },
    get_diadoc_document_list(){
      this.loading = true
      this.$http.v1.getDiadocDocumentList(this.send_filter, (response) => {
        this.diadocs = response.data
        this.loading = false
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    }
  }
}
</script>

<style lang="scss" scoped>
  .document_list {
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;

    .header{
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 10px;
      margin-bottom: 10px;
      .filters{
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        .filter{
          width: 100%;
          .form-group{
            margin: 0;
          }
        }
      }
      .buttons{
        span{
          display: flex;
          gap: 5px;
        }
      }
    }

    .response_table{
      //padding: 10px 0 0;
      padding: 0;
      tbody{
        tr{
          font-size: 12px;
          &:hover{
            background-color: #eeeeee;
          }
          .mdi{
            font-size: 20px;
          }
        }
        .vertical-center{
          vertical-align: middle;
        }

        .text-left{
          text-align: left;
        }

        .limit{
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 1.5em;
          max-height: 3em;
          margin-bottom: 0;
          font-size: 12px;
        }
      }
    }
  }
</style>
